export default file => {
  if (!file) {
    return null
  }

  const { name } = file
  const fileExtensionSeparator = '.'
  const lastIndexOfDot = name.lastIndexOf(fileExtensionSeparator)

  if (lastIndexOfDot > -1) {
    return name
      .slice(lastIndexOfDot + fileExtensionSeparator.length)
      .toLowerCase()
  }

  return ''
}
